
import {
    useSelector,
    ordersActions,
    reservationsActions,
    pricesActions,
    locationActions,
    apiSettings
} from "inbooma-api";
import {useEffect, useState} from "react";
import {Biscuit} from "../../../../../utils";
// @ts-ignore
import * as env from '../../../../../../../cypress.json';

import {Settings as IntSettings} from "./Helper";

interface Props {
    settings: any,
    setSettings?: any,
    setNotification?: any,
    setShouldClose?: any,
    setInitialized?: any
}

type envType = {
    watchForFileChanges : boolean,
        baseUrl : string,
        viewportWidth: number,
        viewportHeight: number,
        video: boolean,
        localApiUrl?: string
}

const envTs = env as envType;
interface APIInterface {
    getApiHost: any,
    setShouldClose: any,
    shouldClose: boolean,
    notification: any,
    setNotification: any,
    settings: any,
    setSettings: any,
    onCloseNotificationHandler: any,
    getOrder: any,
    patchOrder: any,
    postReservation: any,
    patchReservation: any,
    getPrice: any,
    getLocations: any
}

const Settings = {
    API_HOST: 'https://api.inbooma.net/api/',
    API_HOST_STAGING: 'https://staging-api.inbooma.net/api/',
    API_HOST_TEST: 'https://test-api.inbooma.net/api/'
};

export const getApiHost = () => {

    let host: string = Settings.API_HOST;

    if (document.location.host.toLowerCase().indexOf('test-web.inbooma.net') >= 0
        || document.location.host.toLowerCase().indexOf('localhost') >= 0) {
        host = Settings.API_HOST_TEST;
    }

    if (document.location.host.toLowerCase().indexOf('staging-web.inbooma.net') >= 0
        || (document.location.host.toLowerCase().indexOf('localhost') >= 0)
        && document.location.host.toLowerCase().indexOf('staging') >= 0) {
        host = Settings.API_HOST_STAGING;
    }

    if (typeof envTs !== 'undefined' && typeof envTs.localApiUrl !== 'undefined') {
        host = envTs.localApiUrl;
    }

    return host;
}

type SettingsProps = {
    settings: IntSettings,
}
export const setSettings = (props: SettingsProps) => {
    const {settings} = props;
    apiSettings.setSettings({
        client_id: Biscuit.get('user.client_id'),
        apiEntryPoint: getApiHost(),
        apiLanguage: settings?.languageHeader?.headers["Accept-Language"],
        timezone: 'Europe/Berlin', // used by moment-timezone
    });
}





    export const onCloseHandler = () => {

    };



    export const getOrder = (props: Props) => {
        const {settings, setSettings} = props;

        if (settings.orderPending) {
                return;
        }
        let clone: any = {...props.settings};
        settings.dispatch(ordersActions.getOrder({
            token: Biscuit.get('token'),
            suffix: "",
            id: props.settings.id,
            parameters: props.settings.languageHeader
        }));
        clone.orderPending = true;
        setSettings(clone);
    }

   export const patchOrder = (props: Props) => {
        const {settings, setSettings, setNotification, setShouldClose} = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const _order = useSelector((state: { [x: string]: { patchOrder: any; }; }) => state?.["orders"]?.patchOrder);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [initialized, setInitialized] = useState(false);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (_order.success === '' || settings.orderPending) {
                return;
            }
            let clone: any = {...settings};
            if (_order.success === true) {
                clone.order = _order.data;
            } else {
                setNotification(
                    {
                        message: "Failed to patch order",
                        show: true,
                        link: "",
                        linkContent: "",
                        linkHandler: ""
                    }
                );
                setTimeout(() => {
                    setShouldClose(true);
                }, 2000);
            }
            clone.orderPending = false;
            setSettings(clone);
            setInitialized(true);
        }, [_order, props]);

        const initialize = () => {
            const {settings, setSettings} = props;
            if (settings.orderPending || initialized) {
                return;
            }
            let clone = {...props.settings};
            settings.dispatch(ordersActions.getOrder({
                token: Biscuit.get('token'),
                id: settings.id,
                data: settings.cart.order,
                parameters: settings.languageHeader
            }));
            clone.orderPending = true;
            setSettings(clone);
        }

        if (!initialized) {
            initialize();
        }
    }

    export const postReservation = (props: Props) => {
        const {settings, setSettings, setNotification, setShouldClose} = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const _reservation = useSelector((state: {
            [x: string]: { postReservations: any; };
        }) => state?.["reservations"]?.postReservations);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [initialized, setInitialized] = useState(false);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (_reservation.success === '' || settings.reservationPending) {
                return;
            }
            let clone = {...settings};
            if (_reservation.success === true) {
                clone.reservation = _reservation.data;
            } else {
                setNotification(
                    {
                        message: "Failed to post reservation",
                        show: true,
                        link: "",
                        linkContent: "",
                        linkHandler: ""
                    }
                );
                setTimeout(() => {
                    setShouldClose(true);
                }, 2000);
            }
            clone.reservationPending = false;
            setSettings(clone);
            setInitialized(true);
        }, [_reservation, props]);

        const initialize = () => {
            const {settings, setSettings} = props;
            if (settings.reservationPending || initialized) {
                return;
            }
            let clone = {...settings};
            settings.dispatch(reservationsActions.postReservations({
                token: Biscuit.get('token'),
                data: settings.cart.reservation,
                parameters: settings.languageHeader
            }));
            clone.reservationPending = true;
            setSettings(clone);
        }

        if (!initialized) {
            initialize();
        }
    }

    export const patchReservation = (props: Props) => {
        const {settings, setSettings, setNotification, setShouldClose} = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const _reservation: any = useSelector((state: {
            [x: string]: { patchReservations: any; };
        }) => state?.["reservations"]?.patchReservations);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [initialized, setInitialized] = useState(false);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (_reservation.success === '' || settings.reservationPending) {
                return;
            }
            let clone = {...settings};
            if (_reservation.success === true) {
                clone.reservation = _reservation.data;
            } else {
                setNotification(
                    {
                        message: "Failed to patch reservation",
                        show: true,
                        link: "",
                        linkContent: "",
                        linkHandler: ""
                    }
                );
                setTimeout(() => {
                    setShouldClose(true);
                }, 2000);
            }
            clone.reservationPending = false;
            setSettings(clone);
            setInitialized(true);
        }, [_reservation, props]);

        const initialize = () => {
            const {settings, setSettings} = props;
            if (settings.reservationPending || initialized) {
                return;
            }
            let clone = {...props.settings};
            settings.dispatch(reservationsActions.patchReservations({
                token: Biscuit.get('token'),
                reservation_id: settings.cart.reservation.id,
                data: settings.cart.reservation,
                parameters: settings.languageHeader
            }));
            clone.reservationPending = true;
            setSettings(clone);
        }

        if (!initialized) {
            initialize();
        }
    }

    export const getPrice = (props: Props) => {
        const {settings, setSettings, setNotification, setShouldClose} = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const _price: any = useSelector((state: {
            [x: string]: { calculatePrice: any; };
        }) => state?.["prices_data"]?.calculatePrice);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [initialized, setInitialized] = useState(false);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (_price.success === '' || settings.pricePending) {
                return;
            }
            let clone = {...settings};
            if (_price.success === true) {
                clone.cart.price = _price.data;
            } else {
                setNotification(
                    {
                        message: "Failed to get price",
                        show: true,
                        link: "",
                        linkContent: "",
                        linkHandler: ""
                    }
                );
                setTimeout(() => {
                    setShouldClose(true);
                }, 2000);
            }
            clone.pricePending = false;
            setSettings(clone);
            setInitialized(true);
        }, [_price, props]);

        const initialize = () => {
            const {settings, setSettings} = props;
            if (settings.pricePending || initialized) {
                return;
            }
            let clone = {...settings};
            let payload = settings.cart.priceRequestData;
            payload["token"] = Biscuit.get('token');
            payload["parameters"] = settings.languageHeader;
            settings.dispatch(pricesActions.calculatePrice(payload));
            clone.pricePending = true;
            setSettings(clone);
        }

        if (!initialized) {
            initialize();
        }
    }

    export const getLocations = (props: Props) => {
        const {setNotification, setShouldClose} = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const _locationsDynamoDB: any = useSelector((state: {
            [x: string]: { locations_dynamo_db: any; };
        }) => state?.["locations_data"]?.locations_dynamo_db);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [initialized, setInitialized] = useState(false);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            if (_locationsDynamoDB.success === '' || _locationsDynamoDB.settings.locationsPending) {
                return;
            }
            let clone = {...props.settings};
            if (_locationsDynamoDB.success === true) {
                clone.cart.locations = _locationsDynamoDB.data;
            } else {
                setNotification(
                    {
                        message: "Failed to get locations from dynamo db",
                        show: true,
                        link: "",
                        linkContent: "",
                        linkHandler: ""
                    }
                );
                setTimeout(() => {
                    setShouldClose(true);
                }, 2000);
            }
            clone.locationsPending = false;
            props.setSettings(clone);
            setInitialized(true);
        }, [_locationsDynamoDB, props]);

        const initialize = () => {
            if (props.settings.locationsPending || initialized) {
                return;
            }
            let clone = {...props.settings};
            props.settings.dispatch(locationActions.getLocationsDynamoDb());
            clone.locationsPending = true;
            props.setSettings(clone);
        }

        if (!initialized) {
            initialize();
        }
    }
